export const SESSION_START = 'session_start'
export const SIGNUP_SUCCESS = 'account_created'
export const PAYWALL_SHOWN = 'paywall_page_show'
export const PAYMENT_SCREEN_LOAD = 'payment_screen_load'
export const PLAN_CHOSEN = 'paywall_page_completed'
export const CHECKOUT_SHOWN = 'subs_purchase_show'
export const CHECKOUT_SCREEN_LOAD = 'checkout_screen_load'
export const CARD_BRAND_CHOSEN = 'card_checkout_chosen'
export const PAYWALL_CLOSED = 'subs_purchase_screen_close'
export const BUY_SUBSCRIPTION_TAPPED = 'subs_purchase_started'
export const PROCESSING_STARTED = 'processing_started'
export const PAYMENT_ANIMATION = 'payment_animation_screen'
export const SUBSCRIBED = 'subs_purchase_completed'
export const UPSELL_SUBSCRIBED = 'upsell_purchase_completed'
export const LOOKUP_EXPANSION_SHOW = 'lookup_expansion_show'
export const LOOKUP_EXPANSION_PURCHASED = 'lookup_expansion_purchased'
export const LOOKUP_EXPANSION_SKIPPED = 'lookup_expansion_skipped'
export const LOOKUP_EXPANSION_PURCHASE_FAILED = 'lookup_expansion_purchase_failed'
export const EXPERT_GUIDE_SHOW = 'expert_guide_show'
export const EXPERT_GUIDE_PURCHASED = 'expert_guide_purchased'
export const EXPERT_GUIDE_SKIPPED = 'expert_guide_skipped'
export const EXPERT_GUIDE_PURCHASE_FAILED = 'expert_guide_purchase_failed'
export const PAYMENT_DECLINE = 'subs_purchase_failed'
export const DECLINE_TRY_AGAIN = 'payment_declined_try_again'
export const INAPP_PURCHASE_COMPLETED = 'inapp_purchase_completed'
export const INAPP_PURCHASE_FAILED = 'inapp_purchase_failed'
export const TERMS_TAP = 'terms_of_use_tap'
export const POLICY_TAP = 'privacy_policy_tap'
export const PAYMENT_POLICY_TAP = 'payment_policy_tap'
export const CONTACT_US_TAP = 'contact_us_tap'
export const LEAD = 'lead'
export const ONBOARDING_START = 'onboarding_start'
export const POPUP_EVENT = 'payment_successful_popup'

export const GTM_LOAD_TIMEOUT = 'gtm_load_timeout'
export const GTM_NOT_CONFIGURED = 'gtm_not_configured'

export const LOAD = 'load'
export const CLICK = 'click'
export const SL = 'screen__load'
export const OC = 'option__continue'
export const BC = 'button__continue'
export const BS = 'button_scroll'
export const LR = 'link__redirect'
export const OR = 'option__redirect'
export const QR = 'qr__redirect'
export const OS = 'option__select'
export const IS = 'input__select'
